import Header from 'components/Header';
import { Box, useTheme, Tabs, Tab } from '@mui/material';
import React, { useState } from 'react';
import { colorTheme } from '../../theme';
import OrderHistoryDetails from './OrderHistory';
import TodayOrder from './TodayOrder';
// import UserWiseContribution from './UserWiseContribution';
import PlanWiseContribution from './PlanWiseContribution';
import SalesOrder from './SalesOrder';
// import OrderDetailed from './OrderDetailed';
import { type ITabPanelProps } from 'types';
import { strings } from 'i18n/Strings';
import OrdersSummary from './OrdersSummary';
import { useSelector } from 'react-redux';
import { type RootState } from 'store';

function TabPanel(props: ITabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const Orders = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const { isfundOrderProcessing } = useSelector(
    (state: RootState) => state.fund,
  );

  /* Tab Menu */
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    if (!isfundOrderProcessing) {
      setValue(newValue);
    }
  };

  return (
    <Box>
      <Header title="Orders" />

      {/* Seporator */}
      <Box py={2} />

      {/* GRID & CHARTS */}
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label={strings.displayText.todayOrder} />
          <Tab label={strings.displayText.salesOrder} />
          <Tab label={strings.displayText.orderslabel} />
          {/* <Tab label={strings.displayText.userWiserContribution} /> */}
          <Tab label={strings.displayText.planWiseContribution} />
          {/* <Tab label={strings.displayText.orderDetails} /> */}
          <Tab label={strings.displayText.orderSummaryClientLevel} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <TodayOrder />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SalesOrder />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OrderHistoryDetails />
      </TabPanel>
      {/* <TabPanel value={value} index={3}>
      // Not needed for now
        <UserWiseContribution />
      </TabPanel> */}
      <TabPanel value={value} index={3}>
        <PlanWiseContribution />
      </TabPanel>
      {/* <TabPanel value={value} index={5}>
        // Not needed Now
        <OrderDetailed />
      </TabPanel> */}
      <TabPanel value={value} index={4}>
        <OrdersSummary />
      </TabPanel>
    </Box>
  );
};

export default Orders;
